<template>
  <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ActionPanelBody'
}
</script>
